import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

const QUERY = graphql(`
  query resolveStripeAPIStatus($id: ID!) {
    resolveStripeAPIStatus(id: $id)
  }
`);

export default function useResolveStripeAPIStatus(id: string) {
  return useQuery(QUERY, {
    variables: {
      id,
    },
  });
}
